// span_id to text, for quoting cited evidence back to the student.
//
// The ids and the text both come from the server, which segmented the essay
// when the diagnostic ran and stored the result. Nothing is re-derived here:
// re-segmenting in the browser would eventually disagree with what the
// diagnostic cited and the quotations would silently stop appearing.

export function taraSpanText(spans, spanId) {
  if (!spans || !spanId) return null;
  const text = spans[spanId];
  return typeof text === 'string' && text.trim() ? text : null;
}

// A span id with no text renders nothing. The ids are internal and the prompts
// forbid showing them, so a missing quotation is better than a visible p2s3.
export function taraQuotedSpans(spans, spanIds, limit = 2) {
  if (!Array.isArray(spanIds)) return { shown: [], hidden: 0 };
  const resolved = spanIds
    .map((id) => taraSpanText(spans, id))
    .filter((t) => t !== null);
  return {
    shown: resolved.slice(0, limit),
    hidden: Math.max(0, resolved.length - limit),
  };
}
